import React from 'react';
import { 
  Box, 
  Typography, 
  Container,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Button,
  Chip,
  Stack
} from '@mui/material';
import { GitHub as GitHubIcon, OpenInNew as OpenInNewIcon, Info as InfoIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { projects } from '../utils/Project';


const Projects = () => {
  return (
    <Box sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Typography 
          variant="h2" 
          textAlign="center"
          gutterBottom
          sx={{ mb: 2 }}
        >
          My Projects
        </Typography>
        <Typography 
          variant="h6" 
          component="p" 
          textAlign="center" 
          color="text.secondary"
          sx={{ 
            maxWidth: 'md',
            mx: 'auto',
            mb: 6
          }}
        >
          A selection of projects I've worked on, showcasing my skills and expertise in web and desktop application development.
        </Typography>
        
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }, gap: 4 }}>
          {projects.map((project, index) => (
            <Box key={index}>
              <Card 
                sx={{ 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column',
                  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: (theme) => `0 20px 30px rgba(0, 0, 0, 0.3)`,
                  }
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={project.image}
                  alt={project.title}
                  sx={project.title === 'Bandominium' ? { objectFit: 'cover', objectPosition: 'top' } : { objectFit: 'cover' }}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h5" component="h3" gutterBottom>
                    {project.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    {project.summary}
                  </Typography>
                  <Stack direction="row" spacing={1} sx={{ mt: 2, mb: 2, flexWrap: 'wrap', gap: 1, alignItems: 'flex-start', pl: 0, ml: 0 }}>
                    {project.tags.slice(0, 3).map((tag, i) => (
                      <Chip 
                        key={i} 
                        label={tag} 
                        size="small" 
                        color="primary" 
                        variant="outlined" 
                        sx={{ ml: 0 }}
                      />
                    ))}
                    {project.tags.length > 3 && (
                      <Chip
                        label={`+${project.tags.length - 3}`}
                        size="small"
                        color="primary"
                        variant="filled"
                        icon={<InfoIcon fontSize="small" />}
                        sx={{ ml: 0 }}
                      />
                    )}
                  </Stack>
                </CardContent>
                <CardActions>
                  {project.liveUrl && (
                    <Button 
                      size="small" 
                      startIcon={<OpenInNewIcon />} 
                      href={project.liveUrl || ''} 
                      target={project.liveUrl ? "_blank" : undefined} 
                      rel={project.liveUrl ? "noopener noreferrer" : undefined}
                    >
                      View Site
                    </Button>
                  )}
                  <Button
                    size="small"
                    startIcon={<InfoIcon />}
                    component={RouterLink}
                    to={`/projects/${index}`}
                  >
                    More Info  
                  </Button>
                  {project.githubUrl && (
                    <Button 
                      size="small" 
                      startIcon={<GitHubIcon />} 
                      href={project.githubUrl || ''} 
                      target={project.githubUrl ? "_blank" : undefined} 
                      rel={project.githubUrl ? "noopener noreferrer" : undefined}
                    >
                      Code
                    </Button>
                  )}
                </CardActions>
              </Card>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Projects;
